import {createContext} from 'react';
import {WithdrawalHistoryScreenPropsBase} from './WithdrawalHistoryScreen';

const noop = () => {};

export default createContext<WithdrawalHistoryScreenPropsBase>({
  goToAffiliate: noop,
  goToWithdraw: noop,
});
